import React, { Component } from 'react';
import { Modal, Button, Spin } from 'antd';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

class FteDetail extends Component {
    state = {
        visible: false,
        loading: false,
        fteList: [],
        record: {},
    }

    show = (record) => {
        this.setState({
            visible: true,
            fteList: [],
            record
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        const { record: { requirementId, requirementType } } = this.state;
        if (requirementType) {
            this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.member.getRequireMents,
                data: {
                    requirementId,
                    requirementType,
                },
                doneResult: res => {
                    this.setState({
                        loading: false,
                        fteList: res.data.fteList,
                    });
                },
            };
            $.sendRequest(options);
        }
    }

    getColumns = () => {
        const { fteList } = this.state;
        const columns = [{
            title: '时间',
            dataIndex: 'time',
            key: 'time',
            fixed: 'left',
            width: 60,
        }];
        (fteList || []).forEach(i => {
            const time = `${i.year}.${i.month}`;
            columns.push({
                title: time,
                children: [{
                    title: '已分配',
                    dataIndex: `${time}_fte`,
                    key: `${time}_fte`,
                    width: 60,
                }, {
                    title: '预分配',
                    dataIndex: `${time}_pfte`,
                    key: `${time}_pfte`,
                    width: 60,
                }],
            });
        });
        return columns;
    }

    getDataSource = () => {
        const { fteList } = this.state;

        const params = { time: 'FTE' };

        fteList.forEach(i => {
            const time = `${i.year}.${i.month}`;
            params[`${time}_fte`] = i.fte;
            params[`${time}_pfte`] = i.pfte;
        });

        return [params];
    }

    render() {
        const { loading, visible, record: { requirementCode } } = this.state;
        return (
            <Modal
                title='FTE需求明细'
                visible={visible}
                onCancel={this.hide}
                width="800px"
                maskClosable={false}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div style={{ marginBottom: 10 }}>需求编号：{requirementCode}</div>
                    <TableC
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        rowKey="id"
                        pagination={false}
                        className="fteDetail"
                    />
                </Spin>
            </Modal>
        );
    }
}

export default FteDetail;



// WEBPACK FOOTER //
// ./src/components/user/require/components/FteDetail.js